<template>
    <span
        :class="['relative inline-block shrink-0 overflow-hidden bg-transparent align-middle', imageClass]"
    >
        <!-- Background blurred image to fill space beautifully (only when requested) -->
        <img
            v-if="fit === 'contain' && blurredBackground"
            :src="currentSrc"
            class="absolute inset-0 w-full h-full object-cover blur-xl opacity-60 scale-110"
            aria-hidden="true"
        />
        <!-- Main image -->
        <img
            :src="currentSrc"
            :alt="alt || 'Staff photo'"
            :class="foregroundClasses"
            :loading="loading"
            decoding="async"
            @error="useFallback"
        />
    </span>
</template>

<script setup>
import { computed, ref, watch } from 'vue'

const props = defineProps({
    src: {
        type: String,
        default: ''
    },
    alt: {
        type: String,
        default: ''
    },
    fallback: {
        type: String,
        default: '/images/default-avatar.svg'
    },
    imageClass: {
        type: String,
        default: 'w-full h-full'
    },
    fit: {
        type: String,
        default: 'contain',
        validator: (value) => ['contain', 'cover'].includes(value)
    },
    loading: {
        type: String,
        default: 'lazy'
    },
    blurredBackground: {
        type: Boolean,
        default: false
    }
})

const currentSrc = ref(props.src || props.fallback)

const foregroundClasses = computed(() => [
    'relative z-10 h-full w-full',
    props.fit === 'cover' ? 'object-cover object-top' : 'object-contain object-center'
])

watch(
    () => props.src,
    (src) => {
        currentSrc.value = src || props.fallback
    }
)

const useFallback = () => {
    if (currentSrc.value !== props.fallback) {
        currentSrc.value = props.fallback
    }
}
</script>
